import request from '@/utils/request'

// 搜索
export const getHelpSearch = (obj, config = {}) => {
  const params = {
    version: obj.version,
    language: obj.language,
    productId: obj.productId,
    search: obj.search
  }
  // oncChangeSearch 发请求时：标记为 suggest
  // onSearch（回车）发请求时：标记为 submit
  // axios 拦截器里：只对 suggest 进行 abort，submit 永不取消
  return request.get('/tchelp/search/', {
    params,
    ...config
  })
  // return {
  //   status: 200,
  //   data: [
  //     {
  //       code: '00095',
  //       id: '120',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '显示连接失败',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00105',
  //       id: '130',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: 'Total Control 连接掉线问题分类汇总',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00033',
  //       id: '38',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: ' 连接手机时一直加载到某个百分比却始终不显示连接按钮？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '30011',
  //       id: '166',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '华为Huawei&荣耀Honor手机连接步骤',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00038',
  //       id: '43',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '连接100台设备不完全或者不稳定？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00051',
  //       id: '56',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '通过 USB 可以成功连接，但通过 TCP 却始终提示连接失败？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00058',
  //       id: '63',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '连接TC后手机输入法不工作',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00085',
  //       id: '90',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '连接黑屏问题分析与解决',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00099',
  //       id: '124',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: 'TCP 连接时客户端连接时显示需要在手机上点击“同意”，而手机上并未出现同意？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00031',
  //       id: '36',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '连接过程中提示APK安装失败，无法出现连接按钮',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '30010',
  //       id: '164',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: 'OPPO/VIVO/OnePlus/1+ 手机连接步骤',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00036',
  //       id: '41',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '多个手机无法同时连接？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00049',
  //       id: '54',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '小米 Max 手机无法连接？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00054',
  //       id: '59',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: ' TCP 连接需要点击确认？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00082',
  //       id: '87',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: ' TC可以连接安卓模拟器吗？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00097',
  //       id: '122',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '连接闪退',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00007',
  //       id: '12',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: 'Total Control 支持的连接方式有哪些？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '30001',
  //       id: '135',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '小米&红米手机连接步骤',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00034',
  //       id: '39',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '设备连接失败，始终在连接这一步报错，"提示获取屏幕失败"',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00039',
  //       id: '44',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '电脑显示USB控制器资源不足，无法连接100台手机？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00052',
  //       id: '57',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '已经通过 USB 成功连接，但通过 TCP却始终提示需要usb连接一次？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00062',
  //       id: '67',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '已经购买支持连接 10 个设备，如何升级为支持更多数量？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00087',
  //       id: '92',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '显示已连接，任务栏可以看到手机窗口，windows桌面无法显示投屏界面',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00101',
  //       id: '126',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '1019\\1033错误号连接恢复方法',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00032',
  //       id: '37',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '连接手机时一直在“正在启动服务”？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '20014',
  //       id: '165',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: 'WIFI连接模式一：USB初始化后的WIFI连接',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00037',
  //       id: '42',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '如何连接 100 台手机？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00050',
  //       id: '55',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '如何通过 TCP 连接手机？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00056',
  //       id: '61',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: 'Android 8.0 以上的华为手机无法通过 TCP 连接？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00084',
  //       id: '89',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: 'TCP 连接下，手机黑屏一段时间后，连接断开？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00098',
  //       id: '123',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '多控中心连接转圈',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00008',
  //       id: '13',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: 'Total Control 目前可以支持连接控制哪些设备？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '10006',
  //       id: '141',
  //       type: '2',
  //       version: '8.0.u10',
  //       title: '新手入门 - 如何通过 IP 地址连接到设备（以太网和WiFi）',
  //       url: 'https://www.sigma-rt.com/tc/guide-client/?u=10&t=10#g10_1',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00035',
  //       id: '40',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '始终无法连接？试试关闭手机助手软件',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00042',
  //       id: '47',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '连接 100 台设备不完全或者不稳定？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00053',
  //       id: '58',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '通过 TCP 方式连接不稳定，频繁出现掉线的问题？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     },
  //     {
  //       code: '00079',
  //       id: '84',
  //       type: '1',
  //       version: '8.0.u10',
  //       title: '使用支付类软件，手机会黑屏或断开连接？',
  //       url: '',
  //       goto: '',
  //       versions: null
  //     }
  //   ]
  // }
}

// 获取列表
export const getTestExecutionList = () => {
  return request.get('/testExecution')
}
